import React from 'react';
import { PopperProps, ClickAwayListener } from '@mui/material';
import { Dropdown } from './MBDropdown.styles';

export interface MBDropdownProps extends Omit<PopperProps, 'onClose'> {
  onClose: () => void;
  minWidth?: number;
}

const MBDropdown: React.FC<MBDropdownProps> = ({
  children,
  onClose,
  minWidth,
  placement = 'bottom-start',
  ...rest
}) => {
  const handleClickAway = (e: PointerEvent) => {
    if (rest.open && e.target !== rest.anchorEl) {
      onClose?.();
    }
  };

  return (
    <ClickAwayListener
      onClickAway={handleClickAway}
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
    >
      <div>
        <Dropdown {...rest} placement={placement} minWidth={minWidth || 200}>
          {children}
        </Dropdown>
      </div>
    </ClickAwayListener>
  );
};

export default MBDropdown;
